function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "layers");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.248 11.601c0.45 0.313 1.050 0.313 1.5 0l9.088-5.281c0.236-0.164 0.21-0.518-0.048-0.646l-9.205-3.537c-0.368-0.183-0.802-0.183-1.17 0l-9.205 3.537c-0.258 0.127-0.284 0.482-0.048 0.646l9.088 5.281zM19.788 10.811l-2.486-1.233-5.725 3.327c-0.469 0.309-1.014 0.471-1.579 0.471s-1.11-0.163-1.579-0.471l-5.721-3.329-2.49 1.234c-0.258 0.128-0.284 0.482-0.048 0.646l9.088 6.309c0.45 0.313 1.050 0.313 1.5 0l9.088-6.309c0.236-0.163 0.21-0.517-0.048-0.645z"
});

var SvgLayers = function SvgLayers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLayers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/layers.ec7d2666.svg";
export { ForwardRef as ReactComponent };